module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kjrzv"))).then(() => module.bundle.root('2KbAe'));